module.exports = __webpack_public_path__ + "img/9791159311338.41c0c6ea.jpg";